import React from 'react';
import './PageHeader.css';

const PageHeader = ({ title, backgroundImage }) => {
  const style = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : {};

  return (
    <div className={`page-header ${backgroundImage ? 'page-header--has-bg' : ''}`} style={style}>
      <div className="page-header-overlay"></div>
      <div className="page-header-content">
        <h1 className="page-header-title">{title}</h1>
      </div>
    </div>
  );
};

export default PageHeader;
